
/**
 * Module dependencies.
 */

import { createAction } from 'redux-actions'

/**
 * Types.
 */

export const REQUEST_PAYMENTS = 'REQUEST_PAYMENTS'
export const RECEIVE_PAYMENTS = 'RECEIVE_PAYMENTS'

/**
 * Actions.
 */

const requestPayments = createAction(REQUEST_PAYMENTS)
const receivePayments = createAction(RECEIVE_PAYMENTS)

export function fetchPayments (slug) {
  return (dispatch) => {
    dispatch(requestPayments({ slug }))

    // Pretend to be async
    setTimeout(() => {
      dispatch(receivePayments({ slug, data: window.segment.payments }))
    }, 1)
  }
}



// WEBPACK FOOTER //
// ./actions/payments.js